import { RiseOutlined } from "@ant-design/icons";
import { assignInlineVars } from "@vanilla-extract/dynamic";

import { rawPalette } from "../../styles/theme.css";

import {
    iconTitle,
    iconTitleColorVar,
    sectionRoot,
} from "./AIViewSummarySection.css";
import { BulbIcon } from "./BulbIcon";
import { TargetIcon } from "./TargetIcon";

type Icon = "lightbulb" | "target" | "rise";

export interface AIViewSummarySectionProps {
    title: string;
    iconVariant: Icon;
    /** Any CSS color — tints the icon and title. */
    colorVariant?: string;
    children: React.ReactNode;
}

// There is little content in the component but in the future we may want to compose it more, by e.g.
// ensuring a streaming transition for the content
export function AIViewSummarySection({
    title,
    iconVariant,
    colorVariant = rawPalette.text.primary,
    children,
}: AIViewSummarySectionProps) {
    const iconVariantMap = {
        lightbulb: <BulbIcon size={22} />,
        target: <TargetIcon />,
        rise: <RiseOutlined style={{ fontSize: 22 }} />,
    };
    return (
        <div className={sectionRoot}>
            <IconTitle
                colorVariant={colorVariant}
                icon={iconVariantMap[iconVariant]}
            >
                {title}
            </IconTitle>
            <div>{children}</div>
        </div>
    );
}

interface IconTitleProps {
    colorVariant: string;
    icon: React.ReactNode;
    children: React.ReactNode;
}
function IconTitle({ colorVariant, icon, children }: IconTitleProps) {
    return (
        <div
            className={iconTitle}
            style={assignInlineVars({ [iconTitleColorVar]: colorVariant })}
        >
            {icon}
            <span>{children}</span>
        </div>
    );
}
